import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';

export default function GoogleSignInGate({ children }) {
  const { user, loading, handleGoogleSuccess } = useAuth();

  if (loading) {
    return (
      <div className="signin-gate">
        <div className="signin-loading">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="signin-gate">
        <div className="signin-card">
          <img src="/logo.png" alt="Vector Labs" className="signin-logo-img" />
          <h2>Vector Labs</h2>
          <p>Sign in to access our research catalogue and publications.</p>
          <div className="google-btn-wrapper">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => console.error('Google Sign-In failed')}
              theme="outline"
              size="large"
              text="signin_with"
              shape="rectangular"
              width="300"
            />
          </div>
          <span className="signin-note">Required to browse research publications</span>
        </div>
      </div>
    );
  }

  return children;
}
